import React, { useState } from "react";

import PickerItem from "./PickerItem";
import { Tooltip as TooltipLib } from "@npm_leadtech/qr-ui-components";

import { PickerOption, PickerProps } from "./types";

import { ConnectForm } from "@/utils/formHelper";
import { useDraggableScroll } from "@/hooks/ui";

import "./styles.scss";

export function Picker({
  title,
  options,
  multiple,
  id,
  dataQA,
  defaultValue,
  className,
  selector,
  onClick,
}: PickerProps) {
  const defaultOption = typeof options[0] === "string" ? options[0] : options[0].pickerItem;
  const [selectedOption, setSelectedOption] = useState<string | string[]>(
    defaultValue || (multiple ? [] : defaultOption)
  );

  const { ref, onMouseDown, onMouseLeave, onMouseUp, onMouseMove } =
    useDraggableScroll<HTMLUListElement>();

  React.useEffect(() => {
    if (onClick) onClick(selectedOption);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOption]);

  return (
    <ConnectForm>
      {title && <p>{title}</p>}
      <ul
        ref={ref}
        onMouseDown={onMouseDown}
        onMouseLeave={onMouseLeave}
        onMouseUp={onMouseUp}
        onMouseMove={onMouseMove}
        data-testid="Picker"
        data-qa={dataQA}
        className={`Picker${className ? " " + className : ""}`}
        id={id}
      >
        {options.map((option: string | PickerOption, i: number) => {
          const formattedOption = typeof option === "string" ? option : option.pickerItem;
          if (typeof option !== "string" && option.tooltip) {
            return (
              <React.Fragment key={i}>
                <div>
                  <TooltipLib
                    dataQA="picker-tooltip"
                    dataTestId="tooltip"
                    text={option.tooltip?.text}
                    position={option.tooltip?.position}
                  >
                    <PickerItem
                      option={formattedOption}
                      label={option?.label}
                      iconSrc={typeof option !== "string" ? option?.iconSrc : undefined}
                      id={i}
                      multiple={multiple}
                      selectedOption={selectedOption}
                      setSelectedOption={setSelectedOption}
                      selector={selector}
                    />
                  </TooltipLib>
                </div>
              </React.Fragment>
            );
          }

          return (
            <React.Fragment key={i}>
              <PickerItem
                option={formattedOption}
                label={typeof option !== "string" ? option?.label : undefined}
                iconSrc={typeof option !== "string" ? option?.iconSrc : undefined}
                id={i}
                multiple={multiple}
                selectedOption={selectedOption}
                setSelectedOption={setSelectedOption}
                selector={selector}
              />
            </React.Fragment>
          );
        })}
      </ul>
    </ConnectForm>
  );
}
